import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "index",
    meta: {
      title: '域名注册',
    },
    component: () =>
      import("../views/home/index"),
  },
  {
    path: "/search",
    name: "search",
    meta: {
      title: '域名注册',
    },
    component: () =>
      import("../views/home/search"),
  },
  {
    path: "/whoisSearch",
    name: "whoisSearch",
    meta: {
      title: 'WHOIS查询',
    },
    component: () =>
        import("../views/home/whoisSearch"),
  },
  {
    path: "/whois",
    name: "whois",
    meta: {
      title: 'Whois查询',
    },
    component: () =>
        import( "../views/home/whois"),
  },
  {
    path: "/shoppingCart",
    name: "shoppingCart",
    meta: {
      title: '购物车',
    },
    component: () =>
      import("../views/home/shoppingCart"),
  },
  {
    path: "/price",
    name: "price",
    meta: {
      title: '域名注册',
    },
    component: () =>
      import("../views/home/price"),
  },
  {
    path: "/emailc",
    name: "Emailc",
    meta: {
      title: '邮箱认证',
    },
    component: () =>
      import("../views/home/emailAuth"),
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: '登录',
    },
    component: () =>
      import("../views/login/login"),
  },
  {
    path: "/userReg",
    name: "userReg",
    meta: {
      title: '免费注册',
    },
    component: () =>
      import("../views/login/userReg"),
  },
  {
    path: "/forgetPassword",
    name: "forgetPassword",
    meta: {
      title: '忘记密码',
    },
    component: () =>
      import("../views/login/forgetPassword"),
  },
  {
    path: "/customer",
    component: () =>
      import("../views/customer/components/layout"),
    children: [
      {
        path: "",
        name: "customer",
        meta: {
          title: '控制台',
        },
        component: () =>
          import("../views/customer/index"),
      },
      {
        path: "domain",
        name: "domain",
        meta: {
          submenu: "domain",
          menuItem: "domain-myDomain",
          title: '我的域名',
        },
        component: () =>
          import(
            "../views/customer/domain/myDomain/index"
          ),
      },
      {
        path: "template",
        meta: {
          submenu: "domain",
          menuItem: "domain-myTemplate",
          title: '我的模板',

        },
        component: () =>
          import(
            "../views/customer/domain/myTemplate/container"
          ),
        children: [
          {
            path: "",
            name: "template",
            meta: {
              submenu: "domain",
              menuItem: "domain-myTemplate",
              title: "我的模板",

            },
            component: () =>
              import(
                "../views/customer/domain/myTemplate/index"
              ),
          },
          {
            path: "add",
            name: "templateAdd",
            meta: {
              submenu: "domain",
              menuItem: "domain-myTemplate",
              title: "添加模板",

            },
            component: () =>
              import(
                "../views/customer/domain/myTemplate/add"
              ),
          },
          {
            path: "transfer",
            name: "templateTransfer",
            meta: {
              submenu: "domain",
              menuItem: "domain-myTemplate",
              title: "模板过户",

            },
            component: () =>
              import(
                "../views/customer/domain/myTemplate/transfer"
              ),
          },
          {
            path: "default",
            name: "templateDefault",
            meta: {
              submenu: "domain",
              menuItem: "domain-myTemplate",
              title: "设置默认模板",

            },
            component: () =>
              import(
                "../views/customer/domain/myTemplate/default"
              ),
          },
          {
            path: "transferlist",
            name: "templateTransferlist",
            meta: {
              submenu: "domain",
              menuItem: "domain-myTemplate",
              title: "模板过户记录",

            },
            component: () =>
              import(
                "../views/customer/domain/myTemplate/transferlist"
              ),
          },
        ],
      },
      {
        path: "push",
        meta: {
          submenu: "domain",
          menuItem: "domain-push",
          title: "域名PUSH",
        },
        component: () =>
          import(
            "../views/customer/domain/push/container"
          ),
        children: [
          {
            path: "",
            name: "pushIndex",
            meta: {
              submenu: "domain",
              menuItem: "domain-push",
              title: "域名PUSH",

            },
            component: () =>
              import(
                "../views/customer/domain/push/index"
              ),
          },
          {
            path: "receive",
            name: "pushReceive",
            meta: {
              submenu: "domain",
              menuItem: "domain-push",
              title: "收到的请求",

            },
            component: () =>
              import(
                "../views/customer/domain/push/receive"
              ),
          },
          {
            path: "sent",
            name: "pushSent",
            meta: {
              submenu: "domain",
              menuItem: "domain-push",
              title: "发出的请求",

            },
            component: () =>
              import(
                "../views/customer/domain/push/sent"
              ),
          },
        ],
      },
      {
        path: "transferin",
        meta: {
          submenu: "domain",
          menuItem: "domain-transferin",
        },
        component: () =>
          import(
            "../views/customer/domain/transferin/container"
          ),
        children: [
          {
            path: "",
            name: "transferin",
            meta: {
              submenu: "domain",
              menuItem: "domain-transferin",
              title: "域名转入",

            },
            component: () =>
              import(
                "../views/customer/domain/transferin/index"
              ),
          },
          {
            path: "record",
            name: "transferinRecord",
            meta: {
              submenu: "domain",
              menuItem: "domain-transferin",
              title: "域名转入记录",

            },
            component: () =>
              import(
                "../views/customer/domain/transferin/record"
              ),
          },
        ],
      },
      {
        path: "transferout",
        meta: {
          submenu: "domain",
          menuItem: "domain-transferout",
        },
        component: () =>
          import(
            "../views/customer/domain/transferout/container"
          ),
        children: [
          {
            path: "",
            name: "transferout",
            meta: {
              submenu: "domain",
              menuItem: "domain-transferout",
              title: "域名转出",

            },
            component: () =>
              import(
                "../views/customer/domain/transferout/index"
              ),
          },
          {
            path: "record",
            name: "transferoutRecord",
            meta: {
              submenu: "domain",
              menuItem: "domain-transferout",
              title: "域名转出记录",

            },
            component: () =>
              import(
                "../views/customer/domain/transferout/record"
              ),
          },
        ],
      },
      {
        path: "order",
        meta: {
          submenu: "domain",
          menuItem: "domain-order",
        },
        component: () =>
          import(
            "../views/customer/domain/order/container"
          ),
        children: [
          {
            path: "",
            name: "order",
            meta: {
              submenu: "domain",
              menuItem: "domain-order",
              title: "域名订单",

            },
            component: () =>
              import(
                "../views/customer/domain/order/index"
              ),
          },
          {
            path: "detail",
            name: "orderDetail",
            meta: {
              submenu: "domain",
              menuItem: "domain-order",
              title: "域名订单详情",
              toBack: true,

            },
            component: () =>
              import(
                "../views/customer/domain/order/detail"
              ),
          },
        ],
      },
      {
        path: "account",
        meta: {
          submenu: "account",
          menuItem: "account",
        },
        component: () =>
          import("../views/customer/info/container"),
          children: [
            {
              path: "",
              name: "account",
              meta: {
                submenu: "account",
                menuItem: "account-account",
                title: '个人资料',
              },
              component: () =>
                import("../views/customer/info/index"),
            },
            {
              path: "security",
              name: "accountSecurity",
              meta: {
                submenu: "account",
                menuItem: "account-security",
                title: '安全中心',
              },
              component: () =>
                import(
                  "../views/customer/info/security"
                ),
            },
            {
              path: "certified",
              name: "accountCertified",
              meta: {
                submenu: "account",
                menuItem: "account-certified",
                title: '我的认证',
              },
              component: () =>
                import(
                  "../views/customer/info/certified"
                ),
            },
            {
              path: "journal",
              name: "accountJournal",
              meta: {
                submenu: "account",
                menuItem: "account-journal",
                title: "登录日志",

              },
              component: () =>
                import(
                  "../views/customer/info/journal"
                ),
            },
            {
              path: "mail",
              name: "accountMail",
              meta: {
                submenu: "account",
                menuItem: "account-mail",
                title: '站内信',
              },
              component: () =>
                import(
                  "../views/customer/info/mail"
                ),
            },
            {
              path: "myEmail",
              name: "accountMyEmail",
              meta: {
                submenu: "account",
                menuItem: "account-certified",
                title: '邮箱认证',
              },
              component: () =>
                  import(
                      "../views/customer/info/myEmail"
                      ),
            },
            {
              path: "myPersonal",
              name: "accountMyPersonal",
              meta: {
                submenu: "account",
                menuItem: "account-certified",
                toBack: true,
                title: '个人认证',
              },
              component: () =>
                import(
                  "../views/customer/info/myPersonal"
                ),
            },
            {
              path: "myEnterprise",
              name: "userMyEnterprise",
              meta: {
                submenu: "account",
                menuItem: "account-certified",
                toBack: true,
                title: '企业认证',
              },
              component: () =>
                import(
                  "../views/customer/info/myEnterprise"
                ),
            },

            {
              path: "security",
              name: "accountSecurity",
              meta: {
                submenu: "account",
                menuItem: "account-security",
                title: '安全中心',
              },
              component: () =>
                import(
                  "../views/customer/info/security"
                ),
            },
          ],
      },
      {
        path: "finance/account",
        name: "financeAccount",
        meta: {
          submenu: "finance",
          menuItem: "finance-account",
          title: "账户信息",

        },
        component: () =>
          import(
            "../views/customer/finance/account/index"
          ),
      },
      {
        path: "finance/account/recharge",
        name: "financeAccountRecharge",
        meta: {
          submenu: "finance",
          menuItem: "finance-account",
          title: '在线充值',
        },
        component: () =>
          import(
            "../views/customer/finance/account/recharge"
          ),
      },
      {
        path: "finance/account/cashout",
        name: "financeAccountCashout",
        meta: {
          submenu: "finance",
          menuItem: "finance-account",
          title: '资金提现',
        },
        component: () =>
          import(
            "../views/customer/finance/account/cashout"
          ),
      },
      {
        path: "finance/capitaldetails/index",
        name: "financeCapitaldetails",
        meta: {
          submenu: "finance",
          menuItem: "finance-capitaldetails",
          title: "资金明细",

        },
        component: () =>
          import(
            "../views/customer/finance/capitaldetails/index"
          ),
      },
      {
        path: "invoice",
        meta: {
          submenu: "finance",
          menuItem: "finance-invoice",
        },
        component: () =>
          import(
            "../views/customer/finance/invoice/container"
          ),
        children: [
          {
            path: "",
            name: "invoice",
            meta: {
              submenu: "finance",
              menuItem: "finance-invoice",
            },
            component: () =>
              import(
                "../views/customer/finance/invoice/index"
              ),
          },
          {
            path: "apply",
            name: "financeapply",
            meta: {
              submenu: "finance",
              menuItem: "finance-invoice",
            },
            component: () =>
              import(
                "../views/customer/finance/invoice/apply"
              ),
          },
          {
            path: "detail",
            name: "invoicedetail",
            meta: {
              submenu: "finance",
              menuItem: "finance-invoice",
            },
            component: () =>
              import(
                "../views/customer/finance/invoice/detail"
              ),
          },
          {
            path: "info",
            name: "invoiceinfo",
            meta: {
              submenu: "finance",
              menuItem: "finance-invoice",
            },
            component: () =>
              import(
                "../views/customer/finance/invoice/info"
              ),
          },
        ],
      },
      {
        path: "domain/analysis",
        name: "domainAnalysis",
        meta: {
          submenu: "domain",
          menuItem: "domain-myDomain",
          title: '解析设置',
        },
        component: () =>
          import(
            "../views/customer/domain/myDomain/analysis"
          ),
      }
    ],
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
// 路由跳转前钩子
router.beforeEach((to, from, next) => {
  // 如果已经登录了，不能让它打开登录、注册、忘记密码页面
  const isLogin = store.state.token != "";
  if (
    isLogin &&
    (to.name === "login" || to.name === "userReg" || to.name === "forgetPassword")
  ) {
    if (
      from.name === "login" ||
      from.name === "userReg" ||
      from.name === "forgetPassword"
    ) {
      next("/index");
    } else {
      next(from);
    }
    return false;
  }
  // 如果是从其他页面去登录页面,记录原本的路由
  if (to.name === "login") {
    const { name, path, query, params } = from;

    let data = {};
    data["name"] = name || "index";
    data["path"] = path || "/";
    data["query"] = query || {};
    data["params"] = params || {};
    router.app.$store && router.app.$store.commit("MUT_ROUTE", data);
  }
  // 如果未登录进入个人中心
  if (to.fullPath.search("/customer") !== -1 && !isLogin) {
    const { name, path, query, params } = from;
    let data = {};
    data["name"] = name || "index";
    data["path"] = path || "/";
    data["query"] = query || {};
    data["params"] = params || {};
    router.app.$store && router.app.$store.commit("MUT_ROUTE", data);
    next("/index");
    return false;
  }
  // if(to.name)
  next();
  if (to.meta.title) {
    document.title = `${to.meta.title} ` + ' *云创空间网络科技有限公司';
  }
});

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router;
